"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChipStatusCatalog;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../utils/constants");

var _simpleOptions = require("../utils/simpleOptions");

var _excluded = ["label", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useChipStyle = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      borderRadius: "10px",
      padding: "0px 8px"
    },
    label: {
      fontSize: "smaller"
    }
  };
});

var Chip = function Chip(_ref) {
  var label = _ref.label,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useChipStyle();
  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "".concat(classes.root, " ").concat(className)
  }, props), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.label
  }, label));
};

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    valid: {
      // activeok
      backgroundColor: "#001f3f",
      color: "white"
    },
    ready: {
      backgroundColor: "#85144b",
      color: "white"
    },
    reactivated: {},
    revised: {
      backgroundColor: "#932ab6",
      color: "white"
    },
    approved: {
      backgroundColor: "#f39c12",
      color: "white"
    },
    "new": {
      backgroundColor: "#00a65a",
      color: "white"
    },
    invalid: {
      backgroundColor: "rgb(220, 0, 78)",
      color: "white"
    },
    active: {
      backgroundColor: "#0073b7",
      color: "white"
    },
    inactive: {
      backgroundColor: "#eaeaec",
      color: "white"
    },
    rejected: {
      backgroundColor: "#f39c12",
      color: "white"
    },
    deleted: {
      backgroundColor: "#cecece",
      color: "white"
    },
    duplicated: {
      backgroundColor: "#85144b",
      color: "white"
    }
  };
});

function ChipStatusCatalog(_ref2) {
  var code = _ref2.code;
  var classes = useStyle();

  if (Number(code) === _constants.statusCatalog.COMPLETE) {
    //65
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label,
      className: classes.valid
    });
  }

  if (Number(code) === _constants.statusCatalog.AVAILABLE) {
    //16
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label,
      className: classes.ready
    });
  }

  if (Number(code) === _constants.statusCatalog.PENDING_EVALUATE) {
    //8
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label
    });
  }

  if (Number(code) === _constants.statusCatalog.EVALUATE) {
    //4
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label,
      className: classes.revised
    });
  }

  if (Number(code) === _constants.statusCatalog.CROP) {
    // 2
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label,
      className: classes["new"]
    });
  }

  if (Number(code) === _constants.statusCatalog.INPUT) {
    // 64
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label,
      className: classes.active
    });
  }

  if (Number(code) === _constants.statusCatalog.OPEN) {
    // 0
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label,
      className: classes.inactive
    });
  }

  if (Number(code) === _constants.statusCatalog.NOT_AVAILABLE) {
    // -1
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label,
      className: classes.rejected
    });
  }

  if (Number(code) === _constants.statusCatalog.DELETED) {
    // -127
    return /*#__PURE__*/_react["default"].createElement(Chip, {
      size: "small",
      label: (0, _simpleOptions.getStatusCatalogOption)(code).label,
      className: classes.deleted
    });
  }

  return /*#__PURE__*/_react["default"].createElement(Chip, {
    size: "small",
    label: code
  });
}

ChipStatusCatalog.propTypes = {
  /**
   * Kode status katalog edaun
   */
  code: _propTypes["default"].oneOf([65, 16, 8, 4, 2, 64, 0, -1, -127])
};